import Swiper from 'swiper';
import initFollowCursor from './follow-cursor';

const initImageGalleries = (elements) => {
    elements.forEach((element) => {
        let centered = false;
        let loop = false;
        const mouseEl = element.querySelector('.js-follow-cursor');

        if (element.dataset.centered) {
            centered = true;
            loop = true;
        }

        const swiper = new Swiper('.swiper', {
            slidesPerView: 'auto',
            loop,
            centeredSlides: centered,
            watchSlidesProgress: true,
            on: {
                setTranslate(event) {
                    event.slides.forEach((slideEl, index) => {
                        const isVisible = event.visibleSlidesIndexes.includes(index);
                        slideEl.classList.toggle('swiper-slide-fully-visible', isVisible);
                    });
                },
            },
        });

        if (mouseEl) {
            initFollowCursor(mouseEl, element);
        }
    });
};

export default initImageGalleries;
